import { render, staticRenderFns } from "./ManageTabAssociation.vue?vue&type=template&id=a58466a4&"
import script from "./ManageTabAssociation.vue?vue&type=script&lang=js&"
export * from "./ManageTabAssociation.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/ManageTabAssociation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports